import { render, staticRenderFns } from "./GuidePage.vue?vue&type=template&id=033ab56a&scoped=true"
import script from "./GuidePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuidePage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GuidePage.vue?vue&type=style&index=0&id=033ab56a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033ab56a",
  null
  
)

export default component.exports